import React, {useEffect} from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import {
    action_fetch_video_clogs,
    action_add_video_clogs
} from '../../../../store/actions/pages/c-log'
import { useHistory, useParams } from 'react-router-dom'

import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'

import List from './components/list'
import { useQuery } from '../../../hooks/common'
import { useRouteMatch } from 'react-router-dom'
import { matchRoutes } from 'react-router-config'
import routes from '../../../../routes/c-log'


const Details = props => {
    useStyles(classes)
    const params = useParams()
    const pageCLog = useSelector(state => state.pageCLog)
    const dispatch = useDispatch()
    const query = useQuery()
    const store = useStore()
    const history = useHistory();
    const match = useRouteMatch()

    useEffect(() =>{
        const branches = matchRoutes(routes, match.url)
        const routeExample = branches?.[0]?.route;

        window.pageTitle = routeExample?.cn_page
        if (window.GeekoSensors) {
            window.GeekoSensors.Quick('autoTrackSinglePage', {page_title: routeExample?.cn_page})
        }
    },[]);

    useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			delete window.__INITIAL_STATE__
		} else {
            window.scrollTo({
				top: 0,
			})
			Details.fetchData(store, params, query, {})
		}
	}, [params.id])

    const onRequest = () => {
        const id = params.id
        dispatch(action_add_video_clogs({ id, skip: pageCLog?.videoSkip }, {}))
    }

    return <div>
        <div className={classes.List}>
            <List showings={pageCLog.videoClogs} request={onRequest} loading={pageCLog.videoLoading} finished={pageCLog.videoFinished}/>
        </div>
        <span className={classes.FixedIcon} onClick={()=>{history.goBack()}}>&#xe693;</span>
    </div>
}

Details.fetchData = async (store, params, search, headers) => {
    const id = params?.id
    const list = await store.dispatch(action_fetch_video_clogs({ id }, headers))
    // console.log(list)
}

export default Details